import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Button } from '@tb/ui';
import { DICTIONARY } from '../i18n/dictionary';
import { detectLocale } from '../i18n/LocaleProvider';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled render error', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    const locale = detectLocale();

    return (
      <div className="boot">
        <div className="tb-stack" style={{ maxWidth: 420 }}>
          <Alert tone="danger" title={DICTIONARY['boot.failed'][locale]}>
            <span className="tb-mono" style={{ fontSize: 12 }}>
              {error.message}
            </span>
          </Alert>
          <Button icon="refresh" onClick={() => window.location.reload()}>
            {DICTIONARY['boot.retry'][locale]}
          </Button>
        </div>
      </div>
    );
  }
}
